import { api } from "@/APIRequests";
import type { InsuranceListResponse } from "@/features/insurance/types";

export async function getInsuranceList(): Promise<InsuranceListResponse> {
  const params = { showLoader: false };

  return api.patientTyped.get_insurance_list({ params });
}
